import React from 'react';
import logo from '../assets/img/logo.png';

export default function HeaderMenu() {
    return (
        <nav className="navbar navbar-expand-lg navbar-light fixed-top py-3" id="mainNav">
            <div className="container">
                <a className="navbar-brand js-scroll-trigger" href="/"><img src={logo} width="100" height="100" alt="Hondix" /></a>
                <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon" />
                </button>
                <div className="collapse navbar-collapse" id="navbarResponsive">
                    <ul className="navbar-nav ml-auto my-2 my-lg-0">
                        <li className="nav-item"><a className="nav-link js-scroll-trigger" href="/sobre">Sobre</a></li>
                        <li className="nav-item"><a className="nav-link js-scroll-trigger" href="/revenda">Ser revendedor</a></li>
                        <li className="nav-item"><a className="nav-link js-scroll-trigger" href="/catalogo">Catálogo</a></li>
                        <li className="nav-item"><a className="nav-link js-scroll-trigger" href="/contato">Contato</a></li>
                        <li className="nav-item"><a className="nav-link js-scroll-trigger" href="/login">Entrar</a></li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}
